const isBrazil = () => {
    return process.env.GATSBY_COUNTRY === 'BR' ? true : false
}
  
module.exports = isBrazil